import { animate, useMotionValue } from "framer-motion";
import { useRef, useState } from "react";

export const useScroll = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [trackMouse, setTrackMouse] = useState(false);

  const x = useMotionValue(0);

  const handleMouseMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!ref.current) return;
    if (!trackMouse) return;

    const xVal = e.pageX - ref.current.offsetLeft;
    const walk = (xVal - startX) * 2;

    const controls = animate(x, scrollLeft - walk, {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
      onUpdate: (val) => {
        if (!ref.current) return;
        ref.current.scrollLeft = val;
      },
    });
    return controls.stop;
  };

  const handleMouseDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!ref.current) return;

    setTrackMouse(true);

    const startX = e.pageX - ref.current.offsetLeft;
    setStartX(startX);

    const scrollLeft = ref.current.scrollLeft;
    setScrollLeft(scrollLeft);
  };

  const handleMouseLeave = () => {
    setTrackMouse(false);
  };

  const handleMouseUp = () => {
    setTrackMouse(false);
  };

  const handleScroll = () => {
    if (!ref.current) return;

    x.set(ref.current.scrollLeft);
  };

  const handleNext = () => {
    if (!ref.current) return;

    const scrollWidth = ref.current.scrollWidth;
    const clientWidth = ref.current.clientWidth;

    // Mendapatkan panjang batas kanan
    const maxScrollRight = scrollWidth - clientWidth;

    // Memeriksa apakah scroll sudah mencapai batas kanan
    if (ref.current.scrollLeft >= maxScrollRight) return;

    const next = Math.trunc(ref.current.scrollLeft) + 240;
    const controls = animate(x, next, {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
      onUpdate: (val) => {
        if (!ref.current) return;
        ref.current.scrollLeft = val;
      },
    });
    return controls.stop;
  };

  const handlePrev = () => {
    if (!ref.current) return;

    // Memeriksa apakah scroll sudah mencapai batas kiri
    if (ref.current.scrollLeft <= 0) return;

    const prev = ref.current.scrollLeft - 240;
    const controls = animate(x, prev, {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
      onUpdate: (val) => {
        if (!ref.current) return;
        ref.current.scrollLeft = val;
      },
    });
    return controls.stop;
  };

  return {
    ref,
    handleMouseDown,
    handleMouseUp,
    handleScroll,
    scrollLeft,
    handleMouseLeave,
    handleMouseMove,
    handleNext,
    trackMouse,
    handlePrev,
  };
};
